import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImg2 from "../components/HeroImg2"
import Work2 from "../components/Work2"

const Projects = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2 heading = "PROJECTS" text = "View my recent projects"/>
      {/* <Work /> */}
      <Work2 />
      <Footer />
    </div>
  )
}

export default Projects